import { HtmlHTMLAttributes } from 'react';
import { TableHeading } from '../../../../../../../components';
import { parseStringToPlural } from '../../../../../../../utils';
import { Icon, QuickActionFilter } from '../../../../../RevisaoPrecos/Components';
import { BulkAdicionarVerbaButton, BulkApprovedButton, BulkRejectedButton } from '../../../NegociacaoFornecedor/components/ActionButtons';
import styles from './DetalhesDaNegociacaoTableHeading.module.scss';

/** A chave do modal do resumo, compartilhada entre o botao que abre e a tela que o desenha. */
export const MODAL_DO_RESUMO = 'resumoDeEnvio';

export const ROTULO_DO_RESUMO = 'Enviar para o fornecedor';

export type DetalhesDaNegociacaoTableHeadingProps = HtmlHTMLAttributes<HTMLDivElement> & {
  hasSelectedDatapoints: boolean;
  selectedDatapointsLength: number;
  totalElements: number;
  openModal: (name: string) => void;
  isSelected: boolean;
  status?: 'ONGOING' | 'CLOSED';
  onDownload: () => void;
  isDownloadLoading?: boolean;
  onUpload?: () => void;
  onDeleteDatapoints: () => void;
  onBulkApprove?: () => void;
  onBulkReject?: () => void;
  onAdicionarVerba?: () => void;
  isBulkActionLoading?: boolean;
  showUploadButton?: boolean;
  uploadTooltip?: string;
};

export const DetalhesDaNegociacaoTableHeading = ({
  hasSelectedDatapoints,
  selectedDatapointsLength,
  totalElements,
  isSelected,
  status,
  openModal,
  onDownload,
  isDownloadLoading = false,
  onUpload,
  onDeleteDatapoints,
  onBulkApprove,
  onBulkReject,
  onAdicionarVerba,
  isBulkActionLoading = false,
  showUploadButton = false,
  uploadTooltip = 'Adicionar novos produtos por arquivo',
}: DetalhesDaNegociacaoTableHeadingProps) => (
  <TableHeading isSelected={isSelected}>
    <TableHeading.Container>
      <p>
        {hasSelectedDatapoints ? (
          <strong>
            {`${selectedDatapointsLength} produtos
                                    ${parseStringToPlural('selecionado', selectedDatapointsLength)}`}
          </strong>
        ) : (
          <>
            Foram encontrados
            <strong>{` ${totalElements} ${parseStringToPlural('resultado', totalElements)} `}</strong>
            no total
          </>
        )}
      </p>
    </TableHeading.Container>
    <TableHeading.Container>
      {isSelected ? (
        <div className={styles['bulk-actions-container']}>
          {/* Só existe com seleção, porque só aí há a quem aplicar, e só na negociação em andamento,
              porque a fechada é fotografia e não recebe verba nova. */}
          {status === 'ONGOING' && onAdicionarVerba && <BulkAdicionarVerbaButton onClick={onAdicionarVerba} disabled={isBulkActionLoading} />}
          {status === 'ONGOING' && onBulkApprove && onBulkReject && (
            <div className={styles['bulk-buttons-wrapper']}>
              <BulkRejectedButton onClick={onBulkReject} disabled={isBulkActionLoading} />
              <BulkApprovedButton onClick={onBulkApprove} disabled={isBulkActionLoading} />
            </div>
          )}
          <TableHeading.PrimaryButton theme="ghost" onClick={onDeleteDatapoints} disabled={isBulkActionLoading}>
            REMOVER PRODUTOS
          </TableHeading.PrimaryButton>
        </div>
      ) : (
        <>
          {/* Botao com ROTULO, e nao so icone, e o primeiro do grupo: e a acao que fecha a conversa com
              o fornecedor, e um envelope sozinho nao diz o que faz. Abre pelo mesmo par de abertura que
              os demais modais desta tela usam, e nao carrega regra nenhuma -- quem decide o que a lista
              mostra e o proprio modal. */}
          <TableHeading.SecondaryButton
            icon={<Icon icon="MdMailOutline" />}
            onClick={() => {
              openModal(MODAL_DO_RESUMO);
            }}
          >
            {ROTULO_DO_RESUMO}
          </TableHeading.SecondaryButton>
          {showUploadButton && onUpload ? <QuickActionFilter.Button icon="MdUpload" placeholder={uploadTooltip} onClick={onUpload} /> : null}
          <QuickActionFilter.Button
            icon="MdFileDownload"
            placeholder="Baixar todos os produtos"
            onClick={onDownload}
            loading={isDownloadLoading}
            disabled={isDownloadLoading}
          />
          <TableHeading.PrimaryButton
            onClick={() => {
              openModal(status === 'ONGOING' ? 'fecharNegocio' : 'reabrirNegocio');
            }}
          >
            {status === 'ONGOING' ? 'Fechar negócio' : 'reabrir NEGOCIAÇÃO'}
          </TableHeading.PrimaryButton>
        </>
      )}
    </TableHeading.Container>
  </TableHeading>
);
